<div *ngIf="previewCommentItem" class="media mt-4">
    <app-avatar [assigned]="avatarObject" avatarWidth="50" personalStyle=""></app-avatar>
    <div class="media-body ml-2">
        <div class="row">
            <div class="col-12  container">
                <div class="row">
                    <div class="col">
                        <h4 class="mb-2" style="font-weight: bold">{{fullName}}</h4>
                    </div>
                    <div class="col text-right">
                        <span> {{leftTime}}</span>
                    </div>
                </div>
            </div>

        </div>
        {{comment}}
        <div class="col-12 no-padding-left" *ngFor="let attach of attachments">
            <app-attachment-thumbnails [deletePermission]="false" [attachment]="attach"></app-attachment-thumbnails>

        </div>
    </div>

</div>
